import { Alert, Button, Stack, Text } from '@mantine/core';
import { Link2 } from 'react-feather';
import type { MissingMeetingLink } from '../../types';
import { missingLinkText } from './meetingLinkPrompt';

interface MissingMeetingLinkAlertsProps {
  links: MissingMeetingLink[] | null | undefined;
  /** 'coach' speaks to the coach. 'admin' speaks about the coach. */
  audience: 'coach' | 'admin';
  /** Opens the profile field for the platform. Coach only. */
  onAdd?: (platform: MissingMeetingLink['platform']) => void;
}

/**
 * MED-1365 QA round 6 (comment 12672): one note for each meeting platform
 * that the coach's current cohorts use and that has no link on the coach's
 * profile. Renders nothing when no link is missing. The same pattern as
 * CalendlyBookingHealthAlerts.
 */
export function MissingMeetingLinkAlerts({
  links,
  audience,
  onAdd,
}: MissingMeetingLinkAlertsProps) {
  if (!links || links.length === 0) return null;
  return (
    <Stack gap="xs">
      {links.map(link => {
        const text = missingLinkText(link, audience);
        return (
          <Alert
            key={link.platform}
            color="blue"
            variant="light"
            icon={<Link2 size={16} />}
            title={text.title}
            p="sm"
          >
            <Text size="xs">{text.body}</Text>
            {onAdd && text.action && (
              <Button
                size="xs"
                variant="light"
                mt="xs"
                onClick={() => onAdd(link.platform)}
              >
                {text.action}
              </Button>
            )}
          </Alert>
        );
      })}
    </Stack>
  );
}
